import React, { useState, useEffect, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
// import { useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import api from '../../../api'
import Responsive from '../../../assets/config/Responsive'
import Colors from '../../../assets/styles/Colors'
import Loader from '../../../components/Loader'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Title from '../../../components/v2/Title'
import Accordion from '../../../components/v2/accordions/Accordion'
import Checkbox from '../../../components/v2/buttons/Checkbox'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import DialogModal from '../../../components/v2/modals/DialogModal'
import TplProgressbar from '../../../components/v2/progrees-bars/TplProgressbar'
import { RootState, useAppDispatch, useAppSelector } from '../../../store'
import {
  TplState,
  setDiscountUsedSuccessfully,
  setDiscountedPayment,
  setInsurerInfo,
  setOfferTotalPrice,
  setPayment,
  setPromoCode,
  setPromoCodeUsedSuccessfully,
  setPromoCodeValue,
} from '../../../store/tplSlice'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import MovingPrice from '../../../components/v2/MovingPrice'
import { currencySymbol, georgianFormatter } from '../../../domain/types'
import PromoCodesInput from '../../../components/v2/PromoCodesInput'
import { toast } from 'react-toastify'
import { useSelector } from 'react-redux'
import { AuthState } from '../../../store/authSlice'
import { Helmet } from 'react-helmet-async'
import { AppState } from '../../../store/appSlice'
//
//
const TplCheckInformation = () => {
  //
  const dispatch = useAppDispatch()
  //
  const { t } = useTranslation()
  //
  const navigate = useNavigate()
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const auth = useSelector<RootState, AuthState>((state) => state.auth)
  //
  const { data: tplCheckInfo, isLoading: isTplCheckInfoLoading } = api.useGetTplCheckInfoQuery(undefined)
  //
  const { data: productCategories, isLoading: isProductCategoryLoading } =
    api.useGetProductCategoriesListQuery(undefined)
  //
  const categoryId = productCategories?.find((x) => x.slug === 'tpl')?.id || 0
  //
  const { data: informationsheetlist, isLoading: isInformationSheetListLoading } = api.useGetInformationSheetQuery({
    categoryId: categoryId,
    attachmentSlug: 'information-sheet',
  })
  //
  const itemID = informationsheetlist?.find((x) => x.productCategoryId === categoryId)?.id || 0
  //
  const { data: currentInformationSheet, isLoading: isCurrentInformationSheetLoading } =
    api.useGetInformationSheetDetailQuery(itemID, {
      skip: !itemID && true,
    })
  //
  const { screenHeader, checkout, filter } = useAppSelector((data: { tpl: TplState }) => data.tpl)
  //
  const pageTitle = tplCheckInfo?.translations[lang]?.title
  const stepName = tplCheckInfo?.translations[lang]?.stepName
  //
  // ? Discount from promo code
  //
  const promoCodeQuery = `${filter.promoCode !== '' ? `PromoCode=${filter.promoCode}&` : ``}TplPriceId=${
    filter?.offer?.tplPriceId
  }&policyStartDate=${filter.dates?.start}&packageId=${filter.offer?.package.id}${
    auth?.user?.id ? `&userId=${auth?.user?.id}` : ``
  }`
  //
  //
  const {
    data: discountedPayments,
    isLoading: isDiscountedPaymentsLoading,
    error: discountedPaymentsError,
    isSuccess: discountSuccess,
  } = api.useGetTplPaymentDiscountQuery(
    {
      query: promoCodeQuery,
    },
    {
      skip: filter.promoCode && filter.offer?.tplPriceId ? false : true,
      refetchOnMountOrArgChange: true,
    },
  )
  // ? Discount from promo code
  //
  const setPaymentInStore = useCallback(() => {
    // when promo code is used and discounted payment is returned in offer
    if (filter.offer && filter.discountedPayment !== undefined && filter.discountUsedSuccessfully) {
      dispatch(
        setPayment({
          firstPaymentAmount: filter.discountedPayment?.firstPaymentAmount?.discounted,
          monthlyPaymentAmount: filter.discountedPayment?.monthlyPaymentAmount?.discounted,
          totalPaymentAmount: filter.discountedPayment?.totalPaymentAmount?.discounted,
        }),
      )
    }
    // when promo code isn't used and discounted payment is null in offer
    if (filter?.offer && filter?.offer?.payment && !filter.discountUsedSuccessfully) {
      dispatch(
        setPayment({
          firstPaymentAmount: filter.offer.payment.firstPaymentAmount,
          monthlyPaymentAmount: filter.offer.payment.monthlyPaymentAmount,
          totalPaymentAmount: filter.offer.payment.totalPaymentAmount,
        }),
      )
      //
    }
  }, [dispatch, filter.offer, filter.discountedPayment, filter.discountUsedSuccessfully])
  //
  const setDiscountInStore = useCallback(() => {
    //
    if (!discountedPaymentsError && filter?.promoCode !== '') {
      return [
        dispatch(setDiscountUsedSuccessfully(true)),
        dispatch(setPromoCodeUsedSuccessfully(true)),
        dispatch(setDiscountedPayment(discountedPayments)),
      ]
      //
    }

    if (discountedPaymentsError !== undefined && filter.promoCode !== '') {
      //
      return [
        dispatch(setDiscountedPayment(undefined)),
        dispatch(setDiscountUsedSuccessfully(false)),
        dispatch(setPromoCodeUsedSuccessfully(false)),
        toast.error(`${t('promoCodeCantbeUsed')}`, { toastId: 1 }),
      ]
      //
    }
    //
  }, [t, dispatch, discountedPayments, filter?.promoCode, discountedPaymentsError])
  //
  useEffect(() => {
    //
    setPaymentInStore()
    //
    return () => {}
  }, [setPaymentInStore])
  //
  useEffect(() => {
    //
    setDiscountInStore()
    //
    return () => {}
  }, [setDiscountInStore])
  //
  const setPromoCodeInStore = useCallback(() => {
    // if discount isn't used successfully, promo code must be empty string, so error will be showned only once
    if (!filter.discountUsedSuccessfully) {
      dispatch(setPromoCode(''))
    }
    //
  }, [filter.discountUsedSuccessfully, dispatch])
  //
  useEffect(() => {
    setPromoCodeInStore()
    //
    return () => {}
  }, [setPromoCodeInStore])
  //
  const _DiscountValue =
    filter?.offer && filter?.payment && filter.discountedPayment && filter.discountUsedSuccessfully
      ? filter.discountedPayment?.totalPaymentAmount?.saving
      : null
  //
  const _Price =
    filter?.offer && filter?.payment
      ? filter.offer?.paymentScheduleType.slug === 'ONE-TIME'
        ? georgianFormatter.format(filter.payment?.totalPaymentAmount as number)
        : georgianFormatter.format(filter.payment?.firstPaymentAmount as number)
      : '0'
  //
  useEffect(() => {
    if (_Price) {
      dispatch(setOfferTotalPrice(_Price?.toString()))
    }
    //
    return () => {}
  }, [_Price, dispatch])
  //
  const [franiTersModalIsOpen, setFraniTersModalIsOpen] = useState<boolean>(false)
  //
  //
  const closeFraniTersModal = () => {
    setFraniTersModalIsOpen(false)
  }
  //
  //
  const [inurerCompanuTermsModalIsOpen, setFnurerCompanuTermsModalIsOpen] = useState<boolean>(false)
  //
  //
  const closeInsurerCompanyModal = () => {
    setFnurerCompanuTermsModalIsOpen(false)
  }
  //
  //
  const calculateEngineDisplacement = (digit: string) => {
    if (digit && digit.length >= 1) {
      const displacement = Number(digit) / 1000
      const roundedDisplacement = displacement?.toFixed(1)
      return roundedDisplacement
    } else {
      return
    }
  }
  //
  const carEngineCapacity = calculateEngineDisplacement(checkout.insuranceCar.engineCapacity)
  //
  //
  const CheckboxText =
    t('iReadAndAgree') +
    ' ' +
    filter?.offer?.translations?.[lang]?.title +
    `${lang === 'ge' ? ' - ს' : "'s"} ` +
    t('insuranceCondition')
  //
  //
  // auto navigate first page
  useEffect(() => {
    if (!filter.dates?.start) {
      navigate('/tpl-choose-days')
    }
    //
    return () => {}
  }, [filter.dates?.start, navigate])
  //
  //
  const MainLoader =
    isTplCheckInfoLoading ||
    isProductCategoryLoading ||
    isInformationSheetListLoading ||
    isCurrentInformationSheetLoading ||
    isDiscountedPaymentsLoading
  //
  return MainLoader ? (
    <Loader />
  ) : (
    <Wrapper>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageTitle} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      {/* frani terms modal */}
      <DialogModal
        title={`${t('franiConditions')}`}
        isOpen={franiTersModalIsOpen}
        onClose={closeFraniTersModal}
        src={currentInformationSheet?.attachment?.[lang]?.url || ''}
        isPdf={true}
        acceptOnClick={() => [
          dispatch(
            setInsurerInfo({
              fieldName: 'privacyTerm',
              fieldValue: true,
            }),
          ),
          closeFraniTersModal(),
        ]}
        //
        declineOnClick={() => [
          dispatch(
            setInsurerInfo({
              fieldName: 'privacyTerm',
              fieldValue: false,
            }),
          ),
          closeFraniTersModal(),
        ]}
      />
      {/* frani terms modal */}

      {/* insurance company terms */}
      <DialogModal
        title={CheckboxText}
        isOpen={inurerCompanuTermsModalIsOpen}
        onClose={closeInsurerCompanyModal}
        src={filter.offer?.termsPath?.translations?.[lang]?.url || ''}
        isPdf={true}
        acceptOnClick={() => [
          dispatch(
            setInsurerInfo({
              fieldName: 'policyTerm',
              fieldValue: true,
            }),
          ),
          closeInsurerCompanyModal(),
        ]}
        //
        declineOnClick={() => [
          dispatch(
            setInsurerInfo({
              fieldName: 'policyTerm',
              fieldValue: false,
            }),
          ),
          closeInsurerCompanyModal(),
        ]}
      />
      {/* insurance company terms */}

      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />

      <Content>
        <Title text={pageTitle} />

        <TplProgressbar stepName={stepName} />

        <MovingPrice price={filter.offerTotalPrice} currency={filter.currency} />

        {/* BEGIN INSURED INFO */}
        {checkout.forWho === 'for-other' ? (
          <Block>
            <Accordion
              isOpen={false}
              editBtnOnchange={() => navigate('/tpl-for-other')}
              editBtnText={t('edit')}
              title={`${t('insuredPersonalInfo')}`}
            >
              <TextDiv>
                <LeftText>{t('cityzenship')}</LeftText>
                <RightText>{checkout.insured?.cityzenship}</RightText>
              </TextDiv>

              <TextDiv>
                <LeftText>{t('personalNumber')}</LeftText>
                <RightText>{checkout.insured?.idNumber}</RightText>
              </TextDiv>

              <TextDiv>
                <LeftText>{t('dateOfBirth')}</LeftText>
                <RightText>{checkout.insured?.dateOfbirth?.toString()}</RightText>
              </TextDiv>

              {checkout.insured?.translations?.ge?.firstName && (
                <TextDiv>
                  <LeftText>{t('nameInGeorgia')}</LeftText>
                  <RightText>{checkout.insured?.translations?.ge?.firstName}</RightText>
                </TextDiv>
              )}

              {checkout.insured?.translations?.ge?.lastName && (
                <TextDiv>
                  <LeftText>{t('surnameInGeorgia')}</LeftText>
                  <RightText>{checkout.insured?.translations?.ge?.lastName}</RightText>
                </TextDiv>
              )}

              <TextDiv>
                <LeftText>{t('nameInEnglish')}</LeftText>
                <RightText>{checkout.insured?.translations?.en?.firstName}</RightText>
              </TextDiv>

              <TextDiv>
                <LeftText>{t('surnameInEnglish')}</LeftText>
                <RightText>{checkout.insured?.translations?.en?.lastName}</RightText>
              </TextDiv>

              <TextDiv>
                <LeftText>{t('gender')}</LeftText>
                <RightText>
                  {checkout.insured.gender === 'female' && `${t('female')}`}
                  {checkout.insured.gender === 'male' && `${t('male')}`}
                </RightText>
              </TextDiv>
            </Accordion>
          </Block>
        ) : null}
        {/* END INSURED INFO */}

        {/* BEGIN INSURER INFO */}
        <Block>
          <Accordion
            isOpen={false}
            editBtnOnchange={() =>
              checkout.forWho === 'for-other' ? navigate('/tpl-insurer') : navigate('/tpl-for-me')
            }
            editBtnText={t('edit')}
            title={checkout.forWho === 'for-other' ? `${t('yourPersonalInfo')}` : `${t('insuredPersonalInfo')}`}
          >
            <TextDiv>
              <LeftText>{t('cityzenship')}</LeftText>
              <RightText>{checkout.insurer?.cityzenship}</RightText>
            </TextDiv>

            <TextDiv>
              <LeftText>{t('personalNumber')}</LeftText>
              <RightText>{checkout.insurer?.idNumber}</RightText>
            </TextDiv>

            <TextDiv>
              <LeftText>{t('dateOfBirth')}</LeftText>
              <RightText>{checkout.insurer?.dateOfbirth?.toString()}</RightText>
            </TextDiv>

            {checkout.insurer?.translations?.ge?.firstName && (
              <TextDiv>
                <LeftText>{t('nameInGeorgia')}</LeftText>
                <RightText>{checkout.insurer?.translations?.ge?.firstName}</RightText>
              </TextDiv>
            )}

            {checkout.insurer?.translations?.ge?.lastName && (
              <TextDiv>
                <LeftText>{t('surnameInGeorgia')}</LeftText>
                <RightText>{checkout.insurer?.translations?.ge?.lastName}</RightText>
              </TextDiv>
            )}

            <TextDiv>
              <LeftText>{t('nameInEnglish')}</LeftText>
              <RightText>{checkout.insurer?.translations?.en?.firstName}</RightText>
            </TextDiv>

            <TextDiv>
              <LeftText>{t('surnameInEnglish')}</LeftText>
              <RightText>{checkout.insurer?.translations?.en?.lastName}</RightText>
            </TextDiv>

            <TextDiv>
              <LeftText>{t('gender')}</LeftText>
              <RightText>
                {checkout.insurer.gender === 'female' && `${t('female')}`}
                {checkout.insurer.gender === 'male' && `${t('male')}`}
              </RightText>
            </TextDiv>
          </Accordion>
        </Block>
        {/* END INSURER INFO */}

        {/* BEGIN CAR INFO*/}
        <Block>
          <Accordion
            isOpen={false}
            editBtnOnchange={() => navigate('/tpl-car-info')}
            editBtnText={`${t('edit')}`}
            hideEditBtn={true}
            title={`${t('carInfo')}`}
            disableEditBtn={true}
          >
            <TextDiv>
              <LeftText>{t('carRegisterNumber')}</LeftText>
              <RightText>{checkout.insuranceCar.registrationNumber}</RightText>
            </TextDiv>

            <TextDiv>
              <LeftText>{t('vinCode')}</LeftText>
              <RightText>{checkout.insuranceCar.vinCode}</RightText>
            </TextDiv>

            <TextDiv>
              <LeftText>{t('techPassportNumber')}</LeftText>
              <RightText>{checkout.insuranceCar.techPassport}</RightText>
            </TextDiv>

            <TextDiv>
              <LeftText>{t('carType')}</LeftText>
              <RightText>{checkout.insuranceCar.carType}</RightText>
            </TextDiv>

            <TextDiv>
              <LeftText>{t('brand')}</LeftText>
              <RightText>{checkout.insuranceCar.brand}</RightText>
            </TextDiv>

            <TextDiv>
              <LeftText>{t('carModel')}</LeftText>
              <RightText>{checkout.insuranceCar.model}</RightText>
            </TextDiv>

            <TextDiv>
              <LeftText>{t('manufactoreYear')}</LeftText>
              <RightText>{checkout.insuranceCar.yearOfManufacture}</RightText>
            </TextDiv>

            <TextDiv>
              <LeftText>{t('engineCapacity')}</LeftText>
              <RightText>{carEngineCapacity}</RightText>
            </TextDiv>
          </Accordion>
        </Block>
        {/* END CAR INFO */}

        {/* BEGIN POLICY INFO  */}
        <Block>
          <Accordion
            isOpen={true}
            editBtnOnchange={() => alert('edit btn')}
            editBtnText={`${t('edit')}`}
            hideEditBtn={true}
            title={`${t('policyInfo')}`}
            disableEditBtn={true}
          >
            <TextDiv>
              <LeftTextForCompany>{t('insuranceCompany')}</LeftTextForCompany>
              <RightText>{filter.offer?.translations?.[lang]?.title}</RightText>
            </TextDiv>

            <TextDiv>
              <LeftText>{t('productCategory')}</LeftText>
              <RightText>{filter.offer?.policyType}</RightText>
            </TextDiv>

            <TextDiv>
              <LeftText>{t('policyDuration')}</LeftText>
              <RightText>{filter.offer?.days}</RightText>
            </TextDiv>

            <TextDiv>
              <LeftText>{t('startDate')}</LeftText>
              <RightText>{dayjs(filter.dates?.start).format('DD  MMMM  YYYY')}</RightText>
            </TextDiv>

            <TextDiv>
              <LeftText>{t('limit')}</LeftText>
              <RightText>
                {filter.offer?.limit} {currencySymbol(filter.offer?.currency)}
              </RightText>
            </TextDiv>

            <hr />

            <PromoCodesInput
              value={filter?.promoCodeValue || ''}
              onChange={(value) => dispatch(setPromoCodeValue(value))}
              onClick={() => {
                if (filter.promoCodeUsedSuccessfully === false) {
                  //
                  dispatch(setPromoCode(filter?.promoCodeValue))
                  //
                } else {
                  dispatch(setPromoCode(''))
                  //
                  dispatch(setPromoCodeValue(''))
                  //
                  dispatch(setPayment(undefined))
                  //
                  dispatch(setDiscountUsedSuccessfully(false))
                  //
                  dispatch(setPromoCodeUsedSuccessfully(false))
                  //
                  dispatch(setDiscountedPayment(undefined))
                }
                //
              }}
              buttonSize="medium"
              discountValue={_DiscountValue}
              disabled={filter?.promoCode !== '' ? filter.discountUsedSuccessfully : false}
              discountUsedSuccesfully={filter?.promoCode !== '' ? filter.discountUsedSuccessfully : false}
              currency={filter.offer?.currency}
            />

            <hr />

            <TextDiv>
              <LeftText>{t('paymentSchedule')}</LeftText>
              <RightText>{filter.offer?.paymentScheduleType.translations?.[lang]?.title}</RightText>
            </TextDiv>

            {filter?.offer?.paymentScheduleType?.slug === 'ONE-TIME' ? null : (
              <TextDiv>
                <LeftText>{t('annualPaymentTitle')}</LeftText>
                <RightText>
                  {filter.discountedPayment && filter.discountUsedSuccessfully && (
                    <DiscountInfo>{filter.discountedPayment?.totalPaymentAmount?.actual} ₾</DiscountInfo>
                  )}
                  {filter?.payment?.totalPaymentAmount} ₾
                </RightText>
              </TextDiv>
            )}

            <TextDiv style={{ marginTop: '6px' }}>
              <LeftText style={{ color: `${Colors.primaryBlack}` }}>{`${t('currentPayment')}`}</LeftText>
              <PriceInfo>
                {filter.discountedPayment && filter.discountUsedSuccessfully && (
                  <DiscountInfo>
                    {filter.offer?.paymentScheduleType.slug === 'ONE-TIME'
                      ? filter?.offer?.payment?.totalPaymentAmount
                      : filter?.offer?.payment?.firstPaymentAmount}{' '}
                    {currencySymbol(filter.currency)}
                  </DiscountInfo>
                )}

                <PriceText>
                  {georgianFormatter.format(Number(_Price) || 0)} {currencySymbol(filter.offer?.currency)}
                </PriceText>
              </PriceInfo>
            </TextDiv>

            <hr />

            <Checkbox
              id="tpl-check-information-privacy-terms"
              label={`${t('franiConditions')}`}
              checked={checkout.insurer.privacyTerm || false}
              defaultChecked={checkout.insurer.privacyTerm || false}
              onClick={() => setFraniTersModalIsOpen(true)}
            />

            <hr />

            <Checkbox
              id="tpl-check-information-company-terms"
              label={CheckboxText}
              checked={checkout.insurer.policyTerm || false}
              defaultChecked={checkout.insurer.policyTerm || false}
              onClick={() => setFnurerCompanuTermsModalIsOpen(true)}
            />
          </Accordion>
        </Block>
        {/* END POLICY INFO  */}

        <Buttons>
          <NavigationButton text={`${t('back')}`} buttonType="prev" onClick={() => navigate('/tpl-car-info')} />
          <NavigationButton
            text={`${t('next')}`}
            buttonType="next"
            disabled={checkout.insurer.policyTerm === true && checkout.insurer.privacyTerm === true ? false : true}
            onClick={() => {
              if (
                filter &&
                filter.promoCodeValue &&
                filter.promoCodeValue.length >= 2 &&
                !discountedPaymentsError &&
                !discountSuccess
              ) {
                toast.info(`${t('pleaseActivatePromoCode')}`)
              } else {
                navigate('/tpl-policy-registration')
              }
            }}
          />
        </Buttons>
      </Content>

      <BackgroundIcon />
    </Wrapper>
  )
}
//
const PriceText = styled.span`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  text-decoration: none;
  font-weight: 500;
`
const PriceInfo = styled.span`
  color: ${Colors.primaryBlack};
`
//
const DiscountInfo = styled.span`
  font-size: 14px;
  text-decoration: line-through;
  color: ${Colors.nevadaGrey};
  margin-right: 12px;
`
const RightText = styled.div`
  text-align: right;
`
const LeftText = styled.div`
  width: 60%;
`
const LeftTextForCompany = styled.div``
const TextDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  color: ${Colors.nevadaGrey};
  font-size: 14px;
  margin-bottom: 14px;
`
const Block = styled.div`
  max-width: 464px;
  width: 100%;
  margin-inline: auto;
  margin-top: 32px;

  ${Responsive.mobile} {
    margin-top: 24px;
  }
`
const Buttons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-inline: auto;
  width: 100%;
  margin-top: 48px;
  max-width: 368px;

  button {
    width: 100%;
    padding-inline: 0px;
    &:first-child {
      margin-right: 20px;
    }
  }

  ${Responsive.mobile} {
    max-width: 296px;
    margin-top: 40px;
    button {
      &:first-child {
        margin-right: 15px;
      }
    }
  }
`
const Content = styled.div`
  margin-top: 58px;
  z-index: 2;
  padding-inline: 20px;
  width: 100%;

  ${Responsive.mobile} {
    margin-top: 26px;
    width: 100%;
  }
`
const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
  min-height: 100vh;
  /*  */
`

//
export default TplCheckInformation
